import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ConfigState {
  environment: string;
  defaultAppCode: string;
  defaultLocale: string;
  isLoaded: boolean;
  setConfig: (environment: string, defaultAppCode: string, defaultLocale: string) => void;
  fetchConfig: () => Promise<void>;
}

export const useConfigStore = create<ConfigState>()(
  devtools(
    (set) => ({
      environment: "production", // so we don't see any banner on refresh on PROD.
      defaultAppCode: "",
      defaultLocale: "en-GB",
      isLoaded: false,

      setConfig: (environment, defaultAppCode, defaultLocale) =>
        set({ environment, defaultAppCode, defaultLocale, isLoaded: true }),

      fetchConfig: async () => {
        try {
          const response = await fetch("/api/config");
          if (!response.ok) {
            throw new Error("Failed to fetch config");
          }
          const data = await response.json();
          set({
            environment: data.environment || "production",
            defaultAppCode: data.defaultAppCode || "",
            defaultLocale: data.defaultLocale || "en-GB",
            isLoaded: true,
          });
        } catch (error) {
          console.error("Error fetching config:", error);
          // Set defaults on error
          set({
            environment: "production",
            defaultAppCode: "",
            defaultLocale: "en-GB",
            isLoaded: true,
          });
        }
      },
    }),
    { name: "ConfigStore" }
  )
);
